/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_PhotosInputs */

const cs_ebr_fact_photos = /** @type {(inputs: Ebr_Fact_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky`)
};

const en_ebr_fact_photos = /** @type {(inputs: Ebr_Fact_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Ebr_Fact_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_photos = /** @type {((inputs?: Ebr_Fact_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_photos(inputs)
	return cs_ebr_fact_photos(inputs)
});